(function () {
  /**
   * @typedef {{handle: String,sale_price: number, imgUrl: String, title: String, price: String, hasBasicColors: Boolean, variantId: String}} Product
   */
  /**
   * @param {Product} data
   * @param {Boolean} showTilde
   */
  function productCard(data, showTilde = false) {
    const collId = data.handle.split('_')[1];
    const urlPath = data.handle + (data.variantId ? `?${data.variantId}` : '');

    return `
        <div class="item grid__item card--item">
              <a href="/products/${urlPath}" class="product-card" data-component="product-card" 
                 data-variantId="${data.variantId}" data-collId="${collId}"
                 data-imageURL="${data.image_url || data.imgUrl}"
                 data-title="${data.title}"
                 data-price="${data.price || data.min_price }"
              >
              <div class="product-card__imagewrap" style="aspect-ratio:1;">

                  <img src="${
                    data.image_url || data.imgUrl
                  }" class="product-card__imagewrap__img" 
                  alt="${data.title}" style="aspect-ratio:1;object-fit: cover;">
              </div>
              <div class="product-card__content">
                  ${
                    data.hasBasicColors && data.handle?.split('_')[1]
                      ? `
                      <div class="product-card__color-image-container">
                        <img style="width:100%; height:100%" height="auto" width="auto"  src="https://cdn.prod.shop.precocirico.com/collections/${
                          data.handle?.split('_')[1]
                        }/all_basic_colors.png" />
                      </div>
                    `
                      : ''
                  }
                  <h3 class="product-card__title">${data.title}</h3>
  
                  <div class="price" style='display:flex; justify-content:space-between;'>
                  <div class="price__container">
                      <div class="price__regular">
                      <span class="price-item price-item--regular c-font-roboto ${data.sale_price? "card-price__discount": ""}">
                        ${new Intl.NumberFormat('ja-JP').format(data.price)}
                        <span class="small-text">円 (税込)</span>
                        ${showTilde ? '<span class="price-tilde">〜</span>': ''}
                      </span>
                      </div>
                      </span>
                      </div>
                      <span class="fav-heart__container" onclick="event.preventDefault(); event.stopPropagation();">
                        <svg width="25" height="25" viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg" >
                          <path 
                            d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                            fill="none" stroke="#DDC248">
                          </path>
                        </svg>
                      </span>
                  </div>
              </div>
              </a>
          </div>`;
  }

  function favHeart(fill = false) {
    const html = `
      <span class="fav-heart__container">
        <svg width="25" height="25" viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg" >
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill=${
            fill == true ? '#DDC248' : 'none'
          } stroke="#DDC248"></path>
        </svg>
      </span>
    `;

    const div = document.createElement('div');
    div.innerHTML = html;

    return div.firstElementChild;
  }

  window._Components = {
    productCard,
    favHeart,
  };
})();
